import { Result, Space } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { useIntl } from "react-intl";
import { Link, useSearchParams } from "react-router-dom";

export const ForbiddenPage = () => {
  const [searchParams] = useSearchParams();
  const { formatMessage } = useIntl();
  const homeUrl = searchParams.get("homeUrl") || "/";

  return (
    <Result
      status="error"
      title={formatMessage({ id: "forbiddenPage.title" })}
      subTitle={formatMessage({ id: "forbiddenPage.subTitle" })}
      extra={
        <Space direction={"vertical"}>
          <Link to={homeUrl}>
            <DefaultButton>{formatMessage({ id: "button.backHome" })}</DefaultButton>
          </Link>
          <Link to="/">
            <DefaultButton>{formatMessage({ id: "button.backToCustomerSelection" })}</DefaultButton>
          </Link>
        </Space>
      }
    />
  );
};
